import { fetchAuthSession } from "aws-amplify/auth";
import createFetchClient, { type Middleware } from "openapi-fetch";
import createClient from "openapi-react-query";
import type { paths } from "@/api-types";
import { config } from "@/config";
import { notifications } from "@mantine/notifications";
import classes from "@/styles/error-toast.module.css";

const authMiddleware: Middleware = {
  async onRequest({ request }) {
    const { tokens } = await fetchAuthSession();
    if (!tokens || !tokens.idToken) {
      throw new Error("No tokens found");
    }

    request.headers.set("Authorization", tokens.idToken.toString());
    return request;
  },
  async onError({ error }) {
    if ((error as { name?: string })?.name === "AbortError") {
      return;
    }
    notifications.show({
      id: "error",
      position: "top-center",
      title: "Something went wrong!",
      message:
        "We are sorry! Please refresh the page and try again. If the error doesn't ago away please text us at support@woofapy.com",
      color: "red",
      classNames: classes,
      autoClose: false,
    });
    return;
  },
};

export const fetchClient = createFetchClient<paths>({
  baseUrl: config.apiBaseUrl,
});

fetchClient.use(authMiddleware);

export const client = createClient<paths>(fetchClient);
